import React from "react";
import { DatePicker, Form } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import { IntelligenceFormFieldsEnum } from "../enum";
import dayjs from "dayjs";
import { TimeRangePickerProps } from "antd/lib";
import type { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;
export const TimeRangeInput: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
  const disabledDate: RangePickerProps["disabledDate"] = (current, { from }) => {
    const today = dayjs();
    const yesterday = today.subtract(1, "day");
    const twoYearsAgo = today.subtract(2, "year");

    if (!current) return true;

    if (current.isAfter(yesterday, "day") || current.isBefore(twoYearsAgo, "day")) {
      return true;
    }

    if (from) {
      return Math.abs(current.diff(from, "days")) >= 90;
    }

    return false;
  };
  const RangePresetsDefault: TimeRangePickerProps["presets"] = [
    { label: "Last 7 Days", value: [dayjs().add(-8, "d"), dayjs().add(-1, "d")] },
    { label: "Last 14 Days", value: [dayjs().add(-15, "d"), dayjs().add(-1, "d")] },
    { label: "Last 30 Days", value: [dayjs().add(-31, "d"), dayjs().add(-1, "d")] },
    { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs().add(-1, "d")] },
  ];

  return (
    <Form.Item
      className="pb-2"
      label={""}
      name={IntelligenceFormFieldsEnum.TIME_RANGE}
      required
      rules={[
        {
          message: "Please select time range",
          required: true,
        },
      ]}
    >
      <RangePicker
        disabledDate={disabledDate}
        presets={RangePresetsDefault}
        style={{
          width: 400,
          backgroundColor: "white",
        }}
      />
    </Form.Item>
  );
};
